export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#329FA7',
    light: '#F6F6F6',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
  },
  secondary: {
    main: '#FFFFFF',
    light: '#FFFFFF33',
    contrastText: '#22211F',
  },
  text: {
    brand: '#00579C',
    primary: '#011C32',
    secondary: '#3E444E',
    tertiaryLight: '#626D7C',
    tertiary: '#0F0F0F',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    /* Hero: top→bottom; mint holds ~60%, then fades to white */
    brandLight:
      'linear-gradient(180deg, #e8f4f5 0%, #e8f4f5 60%, #ffffff 100%)',
    fill: '#FAFAFA',
    hero1: '#002015B2',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#143F42',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#2C8D94',
    tableSubhead: '#F7F8F8',
    tableBorder: '#BCC2CC',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#F7F8F8',
    secondary: '#F5F3F0',
    light: '#FAFAFA',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#bbe6fb',
    offer: '#2C8D94',
    stepperCompleted: '#081425',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    pricing: '#329FA7',
    learnMore: '#F4F4F4',
    header: '#EBF6FF',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
